import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2c2ad0cc"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-content"
};
const _hoisted_3 = {
  class: "footer-contact w"
};
const _hoisted_4 = {
  class: "footer-contact_left"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "links w"
};
const _hoisted_7 = {
  class: "links-box"
};
const _hoisted_8 = ["href"];
const _hoisted_9 = {
  class: "phone w"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "联系电话:", -1));
const _hoisted_11 = {
  class: "copy-right"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Copyright ©", -1));
const _hoisted_13 = {
  href: "https://beian.miit.gov.cn/",
  target: "_blank"
};
import api from '@/api/api';
import { UPLOADFILEURL } from '@/api/baseURL';
import { setStorage } from '../../utils/storage';

import { onMounted, ref } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    // import { ElementPlus } from '@element-plus/icons-vue';
    onMounted(() => {
      getData();
    });
    const detailInfo = ref({
      slogan: '',
      sysNameEn: '',
      sysPhone: '',
      domainName: '',
      icp: ''
    });
    const linkList = ref([{
      name: '友情链接',
      code: 'friendlyLinks',
      data: []
    }, {
      name: '常用工具',
      code: 'tools',
      data: []
    }, {
      name: '常用网址',
      code: 'website',
      data: []
    }]);
    const getData = async () => {
      let res = await api.getSystemConfig();
      if (res.data.code === 200) {
        detailInfo.value = res.data.data;
        setStorage('currentDetailInfo', res.data.data);
        linkList.value.forEach(item => {
          if (res.data.data[item.code]) {
            item.data = JSON.parse(res.data.data[item.code].replace(/'/g, '"'));
          }
        });
      }
    };
    return (_ctx, _cache) => {
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
        src: `${_unref(UPLOADFILEURL)}?id=${_unref(detailInfo)?.file?.id}`,
        alt: ""
      }, null, 8, _hoisted_5)])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linkList), item => {
        return _openBlock(), _createElementBlock("div", {
          key: item.name,
          class: "link-box"
        }, [_createElementVNode("h1", null, _toDisplayString(item.name), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, obj => {
          return _openBlock(), _createElementBlock("a", {
            key: obj.name,
            class: "link",
            href: obj.url,
            target: "_blank"
          }, _toDisplayString(obj.name), 9, _hoisted_8);
        }), 128))]);
      }), 128))])]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(_unref(detailInfo)?.sysPhone), 1)])]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).domainName), 1), _createElementVNode("span", null, _toDisplayString(_unref(detailInfo).slogan), 1), _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(detailInfo).icp), 1)])], 512)), [[_vShow, _ctx.$route.meta.isShowAppFooter]]);
    };
  }
};